import { itx } from "../../translationItx/itx";
import { ChannelType, channelTypeInfo } from "../../models/ChannelType";
import Page from "../../models/Page";
import Point from "../../models/Point";
import { SequenceStep, enumActions } from "../Guide";
import GuideUtils from "../GuideUtils";
import { ToDoItem } from "../ToDoItem";
import guideSequence_addRoom from "./guideSequence_addRoom";
import openRoomOrFloorSequence from "./multibleSequencesHelp";

// ContextMenuLables.addFloors
function sequence(type: string, lastToDoItem?: ToDoItem): Array<SequenceStep> {
  let firstRoom = state.floors?.sortBy("Tag")[0]?.rooms.sortBy("Tag")[0];

  function getSubsequenceCreateObj(
    toCreateType: "Switch" | "Dimmer" | "Button", // no itx
    firstCreate: boolean,
    point: [number, number],
  ): Array<SequenceStep> {
    let dragImage = "/images/buttons/touch-6.png"; // no itx
    if (toCreateType == "Switch") {
      dragImage = channelTypeInfo(ChannelType.Switch).image;
    } else if (toCreateType == "Dimmer") {
      dragImage = channelTypeInfo(ChannelType.Dimmer).image;
    }
    const positions = firstCreate ? [[60, 90], point] : [point];

    return [
      {
        id: ["toolbar", toCreateType], // no itx
        dragImage: dragImage,
        action: enumActions.drag,
      },
      {
        action: enumActions.call,
        subSequence: () => {
          // calc here last position

          const openPage = state.objectRegistry.getObject(state.activePaneId);
          const area = document.getElementById("mainDrawingArea");
          const height = area?.offsetHeight;
          const width = area?.offsetWidth;
          if (openPage?.className == "Page" && (openPage as Page).isRoomPlan && height && width) {
            const emptyPoint = (openPage as Page).findFreePositionForNewObject(
              new Point((width / 100) * point[0], (height / 100) * point[1]),
            );

            if (emptyPoint) {
              point = [(emptyPoint.x / width) * 100, (emptyPoint.y / height) * 100];
            }
          }
          return [
            {
              action: enumActions.drop,
              positions: positions, // in % des Target Elements
              id: () => {
                return GuideUtils.openRoomDrawingAreaId();
              },
            },
          ];
        },
      },
    ];
  }

  return [
    {
      action: enumActions.call,
      subSequence: () => {
        if (!firstRoom) {
          return [...guideSequence_addRoom("")];
        } else {
          return [];
        }
      },
    },

    {
      action: enumActions.call,
      subSequence: () => {
        const page = state.objectRegistry.getObject(state.activePaneId);

        if (page?.parent?.className == "Room") {
          return [];
        } else {
          if (!firstRoom) {
            firstRoom = state.floors?.sortBy("Tag")[0]?.rooms.sortBy("Tag")[0];
          }
          return [...openRoomOrFloorSequence({ roomGiven: firstRoom })];
        }
      },
    },
    // {
    //   action: enumActions.call,
    //   subSequence: () => {
    //     if (type == "Consumer") {
    //       return [
    //         {
    //           action: enumActions.explain,
    //           text: itx("onBoardingSequences.explainationCreatConsumerButtonDrag"),
    //           id: ["toolbar", toolbarSubId],
    //         },
    //       ];
    //     } else {
    //       return [];
    //     }
    //   },
    // },

    {
      action: enumActions.call,
      subSequence: () => {
        if (type == "Consumer") {
          return [
            ...getSubsequenceCreateObj("Dimmer", true, [40, 50]), // no itx
            ...getSubsequenceCreateObj("Dimmer", false, [25, 25]), // no itx
            ...getSubsequenceCreateObj("Switch", false, [25, 75]), // no itx
          ];
        } else {
          return [...getSubsequenceCreateObj("Button", false, [75, 50])]; // no itx
        }
      },
    },

    // {
    //   action: enumActions.explain,
    //   text: type == "Consumer" ? itx("onBoardingSequences.consumerCreated") : itx("onBoardingSequences.buttonCreated"),
    //   id: () => {
    //     return state.lastCreatedObjectForGuide?.id;
    //   },
    // },
    {
      action: enumActions.call,
      subSequence: () => {
        if (type == "Consumer") {
          // state.selectionManager.selectedObject = channel;
          state.selectionManager.selectedObject = state.lastCreatedObjectForGuide;
          return [
            {
              action: enumActions.wait,
            },
            {
              action: enumActions.function,
              func: async (): Promise<void> => {
                state.selectionManager.selectedObject = state.lastCreatedObjectForGuide;
              },
            },
            {
              action: enumActions.call,
              subSequence: () => {
                const channel = state.lastCreatedObjectForGuide?.getConnectedChannel();

                return [
                  {
                    action: enumActions.explain,
                    text: itx("onBoardingSequences.consumerAutomaticallyConnected"),
                    // text: `
                    // Die Leuchte wurde automatisch mit einem Aktorkanal verbunden.
                    // Der Aktor wird entsprechend der Art der Leuchte ausgewählt.
                    // Wenn es noch keinen Aktor gibt,
                    // wird dieser automatisch angelegt.
                    // `,
                    id: () => {
                      return [`${channel?.id}`];
                    },
                  },
                ];
              },
            },
          ];
        } else {
          return [];
        }
      },
    },
  ];
}

export default sequence;
